import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "header" };
const _hoisted_2 = { class: "header-container" };
const _hoisted_3 = { class: "container" };
const _hoisted_4 = { class: "logo-container" };
const _hoisted_5 = { class: "logo" };
const _hoisted_6 = {
    href: "/",
    title: "Duckhams"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
    key: 0,
    class: "nav-container desktop-nav"
};
const _hoisted_9 = { class: "navigation" };
const _hoisted_10 = ["href"];
const _hoisted_11 = { class: "nav-text" };
const _hoisted_12 = {
    key: 1,
    class: "mobile-controls"
};
const _hoisted_13 = { class: "menu-text-container" };
const _hoisted_14 = { class: "mobile-navigation" };
const _hoisted_15 = ["href"];
const _hoisted_16 = { class: "mobile-nav-text" };
import { ref, onMounted, onUnmounted } from 'vue';
import { useAssets } from '../composables/useAssets';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Header',
    setup(__props) {
        const { assetUrl } = useAssets();
        const navigationItems = [
            { name: "FIND MY OIL", href: "/find-my-oil" },
            { name: "PRODUCTS", href: "/products" },
            { name: "WHERE TO BUY", href: "/where-to-buy" },
            // { name: "ABOUT", href: "/about" },
            // { name: "CONTACT", href: "/contact" },
        ];
        // Configure your search API endpoint here
        const searchApiEndpoint = ref('/api/products/search'); // Update with actual endpoint
        const isMobileMenuOpen = ref(false);
        const isMobileMenuAnimating = ref(false);
        const isDesktop = ref(false);
        const activeSection = ref('');
        // Screen width detection function
        const updateScreenSize = () => {
            isDesktop.value = window.innerWidth >= 1024;
            // Close mobile menu if switching to desktop
            if (isDesktop.value && (isMobileMenuOpen.value || isMobileMenuAnimating.value)) {
                isMobileMenuOpen.value = false;
                isMobileMenuAnimating.value = false;
                document.body.style.overflow = '';
            }
        };
        // Function to set active section based on current path
        const setActiveSection = () => {
            const currentPath = window.location.pathname;
            // Find matching navigation item
            const matchingItem = navigationItems.find(item => currentPath === item.href || currentPath.startsWith(item.href + '/'));
            if (matchingItem) {
                activeSection.value = matchingItem.href.replace('/', '');
            }
            else if (currentPath === '/') {
                // Optional: handle homepage
                activeSection.value = '';
            }
        };
        const disaptchMobileMenuEvent = () => {
            const event = new CustomEvent('mobile-menu-toggled');
            document.dispatchEvent(event);
        };
        const toggleMobileMenu = () => {
            document.body.classList.toggle('fixed-position');
            disaptchMobileMenuEvent();
            if (!isMobileMenuOpen.value) {
                // Opening the menu
                isMobileMenuOpen.value = true;
                isMobileMenuAnimating.value = true;
                document.body.style.overflow = 'hidden';
                setTimeout(() => {
                    const menuItems = document.querySelectorAll('.mobile-nav-link');
                    menuItems.forEach((item, index) => {
                        setTimeout(() => {
                            item.classList.add('active');
                        }, index * 80);
                    });
                }, 200);
            }
            else {
                // Closing the menu - change button state immediately but keep overlay
                isMobileMenuOpen.value = false;
                const menuItems = document.querySelectorAll('.mobile-nav-link');
                // Remove active class in reverse order (last item first)
                menuItems.forEach((item, index) => {
                    setTimeout(() => {
                        item.classList.remove('active');
                    }, (menuItems.length - 1 - index) * 80);
                });
                // Close the overlay and restore scroll after all items have faded out
                setTimeout(() => {
                    isMobileMenuAnimating.value = false;
                    document.body.style.overflow = '';
                }, menuItems.length * 80 + 200);
            }
        };
        const closeMobileMenu = () => {
            if (!isMobileMenuOpen.value && !isMobileMenuAnimating.value)
                return;
            // Change button state immediately but keep overlay
            isMobileMenuOpen.value = false;
            const menuItems = document.querySelectorAll('.mobile-nav-link');
            document.body.classList.remove('fixed-position');
            disaptchMobileMenuEvent();
            // Remove active class in reverse order
            menuItems.forEach((item, index) => {
                setTimeout(() => {
                    item.classList.remove('active');
                }, (menuItems.length - 1 - index) * 80);
            });
            // Close overlay after all items have faded out
            setTimeout(() => {
                isMobileMenuAnimating.value = false;
                document.body.style.overflow = '';
            }, menuItems.length * 80 + 200);
        };
        const handleResize = () => {
            updateScreenSize();
        };
        onMounted(() => {
            window.addEventListener("resize", handleResize);
            // Initialize screen size and active section
            updateScreenSize();
            setActiveSection();
        });
        onUnmounted(() => {
            window.removeEventListener("resize", handleResize);
            // Clean up body overflow style
            document.body.style.overflow = '';
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("header", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("a", _hoisted_6, [
                                    _createElementVNode("img", {
                                        src: _unref(assetUrl)('/images/trade-site/logo.svg'),
                                        alt: "Duckhams Logo"
                                    }, null, 8, _hoisted_7)
                                ])
                            ])
                        ]),
                        (isDesktop.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _createElementVNode("nav", _hoisted_9, [
                                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navigationItems, (item, index) => {
                                        return _createElementVNode("a", {
                                            key: index,
                                            href: item.href,
                                            class: _normalizeClass(["nav-link", { 'active': activeSection.value === item.href.replace('/', '') }])
                                        }, [
                                            _createElementVNode("span", _hoisted_11, _toDisplayString(item.name), 1)
                                        ], 10, _hoisted_10);
                                    }), 64))
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        (!isDesktop.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                _createElementVNode("button", {
                                    onClick: toggleMobileMenu,
                                    class: _normalizeClass(["menu-toggle", { 'active': isMobileMenuOpen.value }])
                                }, [
                                    _createElementVNode("div", _hoisted_13, [
                                        _createElementVNode("span", {
                                            class: _normalizeClass(["menu-text", { 'hidden': isMobileMenuOpen.value }])
                                        }, "Menu", 2),
                                        _createElementVNode("span", {
                                            class: _normalizeClass(["close-text", { 'visible': isMobileMenuOpen.value }])
                                        }, "X", 2)
                                    ])
                                ], 2)
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ]),
                (!isDesktop.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["mobile-menu-overlay", { 'active': isMobileMenuOpen.value || isMobileMenuAnimating.value }]),
                        onClick: closeMobileMenu
                    }, [
                        _createElementVNode("div", {
                            class: "mobile-menu-content container",
                            onClick: _cache[0] || (_cache[0] = _withModifiers(() => { }, ["stop"]))
                        }, [
                            _createElementVNode("nav", _hoisted_14, [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navigationItems, (item, index) => {
                                    return _createElementVNode("a", {
                                        key: index,
                                        href: item.href,
                                        class: _normalizeClass(["mobile-nav-link", { 'active': activeSection.value === item.href.replace('/', '') }]),
                                        style: _normalizeStyle({ animationDelay: isMobileMenuOpen.value ? `${0.1 + index * 0.1}s` : '0s' }),
                                        onClick: closeMobileMenu
                                    }, [
                                        _createElementVNode("span", _hoisted_16, _toDisplayString(item.name), 1)
                                    ], 14, _hoisted_15);
                                }), 64))
                            ])
                        ])
                    ], 2))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
